import { ArrowRightIcon } from 'lucide-react'
import { useNavigate } from 'react-router'

import { useEmployer } from 'pages/employer_onboarding/EmployerProvider'
import { Button, usePageTitle } from 'slab'
import { usePutEmployersEmployersIdUpdateOwnerInvitationFormStatus } from 'utils/web_api'

import { CenteredLayout } from '../employer_onboarding/CenteredLayout'

interface WelcomePageProps {
  isEmployerOnboarding?: boolean
}

export function WelcomePage ({ isEmployerOnboarding = false }: WelcomePageProps) {
  usePageTitle('Verifying your Business')
  const navigate = useNavigate()
  const { employer } = useEmployer()

  const updateOwnerInvitationFormStatus = usePutEmployersEmployersIdUpdateOwnerInvitationFormStatus()

  const handleGetStarted = async () => {
    try {
      await updateOwnerInvitationFormStatus.mutateAsync({
        id: employer?.id ?? '',
        data: { status: 'started' }
      })
      navigate('/employers/verification/owner_invitation/add-individual')
    } catch (error) {
      console.error('Failed to update owner invitation form status:', error)
    }
  }

  const getMessage = () => {
    return (
      <>
        Thatch processes health insurance and qualified medical expense (QME) payments to carriers and providers across the country.
        <br /><br />
        While traditional group insurance plans involve a single payment from employers to carriers, Thatch facilitates the movement of funds that allows employees to choose plans that are right for them. To enable this, Thatch works with several financial institutions to securely move money and process payments.
        <br /><br />
        {isEmployerOnboarding ? 'To utilize services on your behalf, our financial partners require us to verify the identity of individuals with significant ownership and control of your business.' : 'Thatch has transitioned to a new bank partner to better support employers and members. To utilize services on your behalf, our financial partners require us to verify the identity of individuals with significant ownership and control of your business.'}
      </>
    )
  }

  return (
    <CenteredLayout>
      <CenteredLayout.Header
        heading='Verifying your business'
        subheading={getMessage()}
        align='center'
      />
      <CenteredLayout.Buttons align='center'>
        <Button
          variant='primary'
          onClick={handleGetStarted}
          rightIcon={ArrowRightIcon}
          disabled={updateOwnerInvitationFormStatus.isPending}
        >
          Let's get started
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
